/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pre_Render_Frame_Cache_No_Events_ToastInputs */



/**
* | output |
* | --- |
* | "No events found to pre-render" |
*
* @param {Pre_Render_Frame_Cache_No_Events_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const pre_render_frame_cache_no_events_toast = /** @type {((inputs?: Pre_Render_Frame_Cache_No_Events_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pre_Render_Frame_Cache_No_Events_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun événement trouvé à pré-générer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wurden keine Ereignisse gefunden, die vorgerendert werden sollen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun evento trovato da pre-renderizzare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("События для предварительной отрисовки не найдены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron eventos para precargar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未找到要预渲染的事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("事前レンダリングするイベントは見つかりませんでした")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्री-रेंडर करने के लिए कोई इवेंट नहीं मिले")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum evento encontrado para pré-renderizar")
	return /** @type {LocalizedString} */ ("No events found to pre-render")
});